<template>
  <div class="selection-section">
    <div class="selection-section-container">
      <h3>{{ countSelected }} Selected</h3>
      <v-checkbox
        v-model="selected"
        :disabled="totalItems === 0"
        color="primary"
        @click.stop="checkboxClicked()"
      >
        <template #label>
          <p class="select-all-label">Select all</p>
        </template>
      </v-checkbox>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SelectionSection',
    data() {
      return {
        selected: false,
      };
    },
    props: {
      countSelected: { type: Number, required: true },
      totalItems: { type: Number, required: true },
    },
    methods: {
      checkboxClicked() {
        if (this.selected) {
          this.$emit('selectedAll');
        } else {
          this.$emit('unSelectedAll');
        }
      },
    },
    watch: {
      countSelected(newValue) {
        if (this.selected && this.totalItems !== newValue) {
          this.selected = false;
        } else if (!this.selected && this.totalItems === newValue) {
          this.selected = true;
        } else if (this.totalItems === 0) {
          this.selected = false;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .selection-section {
    padding-left: 19px;
    width: 100%;

    .selection-section-container {
      display: flex;
      justify-content: space-between;
    }

    .v-input {
      margin: 0;
    }

    .select-all-label {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      color: #58595b;
    }
  }
</style>
